import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[remote-func]'
})
export class RemoteFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}